import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
import CanbanBoardRoutes from './views/CanbanBoard/CanbanBoardRoutes';
import ProductRoutes from './views/product/ProductRoutes';
import CategoryRoutes from './views/category/CategoryRoutes';
import PipelineRoutes from './views/pipeline/PipelineRoutes';
// import ProductTable from './form/ProductTable';
import TaskRoutes from './views/task/TaskRoutes';
import CustomerRoutes from './views/Customer/CustomerRoutes';
import TransRoutes from './views/finance/TransRoutes';
import OrderRoutes from './views/order/OrderRoutes';
import BankRoutes from './views/bank/BankRoutes';
import ProfileRoutes from './views/profile/ProfileRoutes';
import StaffRoutes from './views/staff/StaffRoutes';
import BannerRoutes from './views/banner/BannerRoutes';
import LogRoutes from './views/log/LogRoutes';
import LiveshareRoutes from './views/liveshare/LiveshareRoutes';
import FeaturesRoutes from './views/features/FeaturesRoutes';
import Shopping from './views/dashboard/Shopping';
import CheckoutPage from './views/dashboard/CheckoutPage';
import AdRoutes from './views/ad/AdRoutes';
import CarrierRoutes from './views/carrier/CarrierRoutes';
import MaintenanceRoutes from './views/maintenance/MaintenanceRoutes';
import TerminalRoutes from './views/terminal/TerminalRoutes';
import UserRoutes from './views/user/UserRoutes';
import ReportRoutes from './views/report/ReportRoutes';
import GroupRoutes from './views/group/GroupRoutes';
import BottomBannerRoutes from './views/bottom/BottomBannerRoutes';
import DiscountBannerRoutes from './views/discount/DiscountBannerRoutes';
import CompanyRoutes from './views/company/CompanyRoutes';
import SubSellerRoutes from './views/subsellers/SubSellerRoutes';
import DebugLogRoutes from './views/debug/DebugLogRoutes';
import VehicleRoutes from './views/vehicle/VehicleRoutes';
import AlertRoutes from './views/alert/AlertRoutes';
import FmcsaRoutes from './views/fmcsa/FmcsaRoutes';
const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));
const JwtRegister = Loadable(
	lazy(() => import('app/views/sessions/JwtRegister'))
);
const ForgotPassword = Loadable(
	lazy(() => import('app/views/sessions/ForgotPassword'))
);
// dashboard page
const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));
const Inventory = Loadable(lazy(() => import('app/views/dashboard/Inventory')));

const routes = [
	{
		element: (
			<AuthGuard>
				<MatxLayout />
			</AuthGuard>
		),
		children: [
			{
				path: '/dashboard/default',
				element: <Analytics />,
				auth: authRoles.admin,
			},
			{
				path: '/dashboard/dailylogs',
				element: <Shopping />,
				auth: authRoles.admin,
			},
			// {
			// 	path: '/tracking',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/unidentified',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/malfunctions',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/voilations',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/notifications',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/dvir',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/documents',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/fmcsa',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/logedit',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/liveshare',
			// 	element: <Shopping />,
			// 	auth: authRoles.admin,
			// },
			// {
			// 	path: '/dashboard/agenttran',
			// 	element: <ProductTable />,
			// 	auth: authRoles.admin,
			// },
			{
				path: '/dashboard/inventory',
				element: <Inventory />,
				auth: authRoles.admin,
			},
			...CanbanBoardRoutes,
			...ProductRoutes,
			...CategoryRoutes,
			...TaskRoutes,
			...PipelineRoutes,
			...CustomerRoutes,
			...TransRoutes,
			...OrderRoutes,
			...BankRoutes,
			...ProfileRoutes,
			...StaffRoutes,
			...BannerRoutes,
			...FeaturesRoutes,
			...AdRoutes,
			...BottomBannerRoutes,
			...DiscountBannerRoutes,
			...LogRoutes,
			...LiveshareRoutes,
			...CarrierRoutes,
			...TerminalRoutes,
			...MaintenanceRoutes,
			...UserRoutes,
			...ReportRoutes,
			...GroupRoutes,
			...AlertRoutes,
			...CompanyRoutes,
			...SubSellerRoutes,
			...DebugLogRoutes,
			...VehicleRoutes,
			...FmcsaRoutes,
		],
	},

	// session pages route
	{ path: '/session/404', element: <NotFound /> },
	{ path: '/session/signin', element: <JwtLogin /> },
	{ path: '/session/signup', element: <JwtRegister /> },
	{ path: '/session/forgot-password', element: <ForgotPassword /> },

	{ path: '/', element: <Navigate to='/session/signin' /> },
	{ path: '*', element: <NotFound /> },
];

export default routes;
